<template>
	<div class="form-test-drive-completed-modal form" :class="{ 'nitea-modal-inner': isModalMode }">
		<div class="form-test-drive-completed-repost-card form-inner">

			<div v-if="isModalMode" class="form-header-container flex-row flex-align-center flex-justify-between">
				<button type="button" class="nitea-modal-close nitea-button is-primary is-outlined is-width-auto is-size-small has-icon-only" @click="closeModal()" aria-label="Stäng">
					<span class="icon-close icon--small"></span>
				</button>
				<div v-if="formTitle || formDescription" class="form-header">
					<template v-if="formTitle || (formDescription && mailSentStatus == null)">
						<h2 v-if="formTitle" class="form-title has-medium-font-size">{{ formTitle }}</h2>
						<p v-if="formDescription" class="form-description">{{ formDescription }}</p>
					</template>
				</div>
			</div>

			<div v-if="mailSentStatus == 'sent'">
				<h2 class="form-section-title has-large-font-size font-weight-medium">Tack!</h2>
				<p>Din förfrågan om provkörning har skickats!</p>
			</div>
			<div v-else-if="mailSentStatus == 'error'">
				<h2 class="form-section-title has-large-font-size font-weight-medium">Förlåt!</h2>
				<p>Men ditt meddelande kunde inte skickas! Vänligen ring oss</p>
			</div>

			<form v-if="mailSentStatus === null || mailSentStatus === 'sending'" class="form-container">
				<div class="form-grid-wrapper">
					<!-- <h2 class="form-section-title has-medium-font-size font-weight-medium">Boka provkörning</h2> -->
					<div class="form-grid">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.firstName.$dirty && $v.fields.firstName.$error,
								'has-success': $v.fields.firstName.$dirty && !$v.fields.firstName.$error && fields.firstName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-firstname'" placeholder=" " v-model="fields.firstName" @blur="$v.fields.firstName.$touch()" required="required" autocomplete="given-name" />
							<label :for="blockId + '-firstname'" class="floating-label">Förnamn</label>
							<div v-if="$v.fields.firstName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt förnamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.lastName.$dirty && $v.fields.lastName.$error,
								'has-success': $v.fields.lastName.$dirty && !$v.fields.lastName.$error && fields.lastName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-lastname'" placeholder=" " v-model="fields.lastName" @blur="$v.fields.lastName.$touch()" required="required" autocomplete="family-name" />
							<label :for="blockId + '-lastname'" class="floating-label">Efternamn</label>
							<div v-if="$v.fields.lastName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt efternamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.email.$dirty && $v.fields.email.$error,
								'has-success': $v.fields.email.$dirty && !$v.fields.email.$error && fields.email.length > 0,
							}"
						>
							<input type="email" :id="blockId + '-email'" placeholder=" " v-model="fields.email" @blur="$v.fields.email.$touch()" required="required" autocomplete="email" />
							<label :for="blockId + '-email'" class="floating-label">E-post</label>
							<div v-if="$v.fields.email.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange en giltig e-postadress</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.mobilephone.$dirty && $v.fields.mobilephone.$error,
								'has-success': $v.fields.mobilephone.$dirty && !$v.fields.mobilephone.$error && fields.mobilephone.length > 0,
							}"
						>
							<input type="tel" :id="blockId + '-mobilephone'" placeholder=" " v-model="fields.mobilephone" @blur="$v.fields.mobilephone.$touch()" required="required" autocomplete="tel" />
							<label :for="blockId + '-mobilephone'" class="floating-label">Mobilnummer</label>
							<div v-if="$v.fields.mobilephone.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt mobilnummer</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.registrationNumber.$dirty && $v.fields.registrationNumber.$error,
								'has-success': $v.fields.registrationNumber.$dirty && !$v.fields.registrationNumber.$error && fields.registrationNumber && fields.registrationNumber.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-regnr'" placeholder=" " v-model="fields.registrationNumber" @blur="$v.fields.registrationNumber.$touch()" required="required" minlength="6" autocomplete="off" style="text-transform: uppercase;" />
							<label :for="blockId + '-regnr'" class="floating-label">Registreringsnummer</label>
							<div v-if="$v.fields.registrationNumber.$error || registrationNumber.error" class="validation-messages">
								<div class="validation-message error" v-if="!$v.fields.registrationNumber.required">Vänligen ange registreringsnummer</div>
								<div class="validation-message error" v-if="!$v.fields.registrationNumber.minLength">Registreringsnummer måste vara minst 6 tecken</div>
								<div class="validation-message error" v-if="registrationNumber.error">{{ registrationNumber.error }}</div>
							</div>
							<div class="field-result car-info" v-if="car || registrationNumber.isLoading">
								<p v-if="car">{{ car.brand }} {{ car.model }} - {{ car.model_year }}</p>
								<p v-if="registrationNumber.isLoading">Hämtar bilinformation...</p>
							</div>
						</div>

						<div
							v-if="showManualBrandModelFields"
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.manualBrand.$dirty && $v.fields.manualBrand.$error,
								'has-success': $v.fields.manualBrand.$dirty && !$v.fields.manualBrand.$error && fields.manualBrand && fields.manualBrand.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-manual-brand'" placeholder=" " v-model="fields.manualBrand" @blur="$v.fields.manualBrand.$touch()" />
							<label :for="blockId + '-manual-brand'" class="floating-label">Märke</label>
							<div v-if="$v.fields.manualBrand.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange bilmärke</div>
							</div>
						</div>
						<div
							v-if="showManualBrandModelFields"
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.manualModel.$dirty && $v.fields.manualModel.$error,
								'has-success': $v.fields.manualModel.$dirty && !$v.fields.manualModel.$error && fields.manualModel && fields.manualModel.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-manual-model'" placeholder=" " v-model="fields.manualModel" @blur="$v.fields.manualModel.$touch()" />
							<label :for="blockId + '-manual-model'" class="floating-label">Modell</label>
							<div v-if="$v.fields.manualModel.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange bilmodell</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.personnummer.$dirty && $v.fields.personnummer.$error,
								'has-success': $v.fields.personnummer.$dirty && !$v.fields.personnummer.$error && fields.personnummer.length > 0,
							}"
						>
							<input type="tel" :id="blockId + '-personnummer'" placeholder="ååååmmdd-xxxx" v-model="fields.personnummer" @blur="$v.fields.personnummer.$touch()" required="required" inputmode="numeric" autocomplete="off" pattern="\d{8}-\d{4}" />
							<label :for="blockId + '-personnummer'" class="floating-label">Personnummer</label>
							<div v-if="$v.fields.personnummer.$error" class="validation-messages">
								<div v-if="!$v.fields.personnummer.required" class="validation-message error">Vänligen ange ditt personnummer</div>
								<div v-else class="validation-message error">Ange 12 siffror | ååååmmdd-xxxx</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-success': fields.licenseValidUntil && fields.licenseValidUntil.length > 0,
							}"
						>
							<input type="date" :id="blockId + '-license'" placeholder=" " v-model="fields.licenseValidUntil" />
							<label :for="blockId + '-license'" class="floating-label">Körkort giltigt till</label>
						</div>

						<div
							v-if="isTest"
							class="form-group floating-label"
							:class="{
								'has-success': fields.userId && fields.userId.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-user-id'" placeholder=" " v-model="fields.userId" autocomplete="off" />
							<label :for="blockId + '-user-id'" class="floating-label">Unikt ID (dolt i produktion)</label>
						</div>
					</div>
				</div>

				<div class="form-footer column gap-normal flex-start align-start">
					<div class="column">
						<div
							class="radio-group gap-small row no-wrap"
							:class="{ 'has-error': $v.fields.testDrivePolicy.$dirty && $v.fields.testDrivePolicy.$error }"
						>
							<input type="checkbox" :id="blockId + '-test-drive-policy'" v-model="fields.testDrivePolicy" @change="$v.fields.testDrivePolicy.$touch()" />
							<label :for="blockId + '-test-drive-policy'" class="has-caption-font-size">
								Jag samtycker till Torvalla Bils
								<a href="https://www.torvallabil.se/allmanna-villkor-provkorning/" target="_blank" rel="noopener" class="has-caption-font-size">policy för provkörningar</a>.
							</label>
						</div>
						<div v-if="$v.fields.testDrivePolicy.$dirty && $v.fields.testDrivePolicy.$error" class="validation-messages">
							<div class="validation-message error">Du måste samtycka till policyn för provkörningar</div>
						</div>
					</div>
					<!-- <p class="has-caption-font-size">För att kunna tillhandahålla dig det innehåll du efterfrågar behöver vi lagra och behandla dina personuppgifter. Om du samtycker till att vi lagrar dina personuppgifter för detta ändamål, vänligen kryssa i kryssrutan nedan.</p> -->
					
					<div class="column">
						<div
							class="radio-group gap-small row no-wrap"
							:class="{ 'has-error': $v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$error }"
						>
							<input type="checkbox" :id="blockId + '-privacy-policy'" v-model="fields.privacyPolicy" @change="$v.fields.privacyPolicy.$touch()" />
							<label :for="blockId + '-privacy-policy'" class="has-caption-font-size">
								Jag samtycker till att torvallabil.se lagrar och behandlar
								<a href="https://www.torvallabil.se/integritetspolicy/" target="_blank" rel="noopener" class="has-caption-font-size">mina personuppgifter</a>.
							</label>
						</div>
						<div v-if="$v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$error" class="validation-messages">
							<div class="validation-message error">Du måste samtycka till behandling av personuppgifter</div>
						</div>
					</div>


				</div>
				<button
					type="button"
					:class="{
						'is-loading': mailSentStatus === 'sending',
						'is-disabled': isFormDisabled,
						'is-filled': !isFormDisabled && !mailSentStatus,
					}"
					class="nitea-button is-primary is-width-auto is-size-default"
					@click="submitForm()"
					:disabled="isFormDisabled"
				>
					Skicka
				</button>
			</form>
		</div>
	</div>
</template>

<script>
	import { required, email, minLength, requiredIf } from "vuelidate/lib/validators";

	const mustBeTrue = (value) => value === true;
	const personnummerFormat = (value) => {
		if (!value) {
			return true;
		}
		return /^\d{8}-?\d{4}$/.test(String(value).replace(/\s/g, ""));
	};

	export default {
		name: "form-test-drive-completed",
		props: {
			postId: {
				type: Number,
				default: null,
			},
			isModalOpen: {
				type: Boolean,
				default: false,
			},
			formTitle: {
				type: String,
				default: "",
			},
			formDescription: {
				type: String,
				default: "",
			},
			blockId: {
				type: String,
				default: "form-test-drive-completed",
			},
			emailRecipients: {
				type: String,
				default: "",
			},
			emailSubject: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				mailSentStatus: null,
				fields: {
					firstName: "",
					lastName: "",
					email: "",
					mobilephone: "",
					registrationNumber: "",
					manualBrand: "",
					manualModel: "",
					personnummer: "",
					licenseValidUntil: "",
					userId: "",
					testDrivePolicy: false,
					privacyPolicy: false,
				},
				registrationNumber: {
					isLoading: false,
					error: null,
				},
				car: null,
				localEmailRecipients: this.emailRecipients,
				localEmailSubject: this.emailSubject,
				carInfoTimeout: null,
			};
		},
		computed: {
			isModalMode() {
				return this.isModalOpen;
			},
			isFormDisabled() {
				return this.mailSentStatus === "sending" || this.$v.fields.$invalid;
			},
			isTest() {
				return Boolean(window.nitea_utils_forms_test_drive_completed && window.nitea_utils_forms_test_drive_completed.is_test);
			},
			showManualBrandModelFields() {
				return !this.car && this.registrationNumber.error === "Kunde inte hämta bilinformation";
			},
		},
		validations: {
			fields: {
				firstName: { required },
				lastName: { required },
				email: { required, email },
				mobilephone: { required },
				registrationNumber: { required, minLength: minLength(6) },
				manualBrand: {
					required: requiredIf(function () {
						return this.showManualBrandModelFields;
					}),
				},
				manualModel: {
					required: requiredIf(function () {
						return this.showManualBrandModelFields;
					}),
				},
				personnummer: { required, personnummerFormat },
				testDrivePolicy: { mustBeTrue },
				privacyPolicy: { mustBeTrue },
			},
		},
		watch: {
			emailRecipients(newVal) {
				this.localEmailRecipients = newVal;
			},
			emailSubject(newVal) {
				this.localEmailSubject = newVal;
			},
			"fields.registrationNumber": {
				handler(newVal) {
					if (newVal) {
						this.fields.registrationNumber = newVal.toUpperCase();
						clearTimeout(this.carInfoTimeout);
						this.carInfoTimeout = setTimeout(() => {
							if (newVal.length >= 6) {
								this.getCarInfo(this.fields.registrationNumber);
							}
						}, 500);
					} else {
						this.car = null;
						this.registrationNumber.error = null;
					}
				},
				immediate: false,
			},
		},
		mounted() {
			if (!this.postId && this.$el && this.$el.hasAttribute("data-post-id")) {
				const postId = this.$el.getAttribute("data-post-id");
				this.postId = postId ? parseInt(postId) : null;
			}

			if (!this.formTitle && this.$el && this.$el.hasAttribute("data-form-title")) {
				this.formTitle = this.$el.getAttribute("data-form-title") || "";
			}
			if (!this.formDescription && this.$el && this.$el.hasAttribute("data-form-description")) {
				this.formDescription = this.$el.getAttribute("data-form-description") || "";
			}

			if (this.$el && this.$el.hasAttribute("data-block-id")) {
				this.blockId = this.$el.getAttribute("data-block-id") || "form-test-drive-completed";
			}

			const urlParams = new URLSearchParams(window.location.search);
			this.fields.userId = urlParams.get("i") || urlParams.get("user_id") || "";
		},
		methods: {
			async getCarInfo(registrationNumber) {
				this.registrationNumber.isLoading = true;
				this.car = null;
				this.registrationNumber.error = null;
				this.fields.manualBrand = "";
				this.fields.manualModel = "";

				registrationNumber = registrationNumber
					.toString()
					.toUpperCase()
					.replace(" ", "")
					.trim();

				if (registrationNumber.length < 6) {
					this.registrationNumber.isLoading = false;
					return;
				}

				const formData = new FormData();
				formData.append("registration_number", registrationNumber);
				formData.append("action", "nitea_utils_form_get_car_info");

				await fetch(window.nitea_utils_forms_test_drive_completed.admin_url + "?action=nitea_utils_form_get_car_info", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.data && data.data.result) {
							this.car = data.data.result;
						} else {
							this.registrationNumber.error = "Kunde inte hämta bilinformation";
						}
						this.registrationNumber.isLoading = false;
					})
					.catch(() => {
						this.registrationNumber.error = "Kunde inte hämta bilinformation";
						this.registrationNumber.isLoading = false;
					});
			},
			closeModal() {
				window.dispatchEvent(
					new CustomEvent("closeFormModal", {
						detail: { formType: "test-drive-completed" },
					}),
				);
			},
			submitForm() {
				this.$v.$touch();
				if (this.$v.$invalid) {
					return;
				}

				this.mailSentStatus = "sending";

				const formData = new FormData();
				formData.append("action", "nitea_utils_form_post_test_drive_completed");
				formData.append("post_id", this.postId || "");
				formData.append("first_name", this.fields.firstName);
				formData.append("last_name", this.fields.lastName);
				formData.append("email", this.fields.email);
				formData.append("mobilephone", this.fields.mobilephone);
				formData.append(
					"registreringsnummer_provkorning",
					this.car && this.car.plate ? this.car.plate : this.fields.registrationNumber,
				);
				if (this.showManualBrandModelFields) {
					formData.append("car_brand", this.fields.manualBrand);
					formData.append("car_model", this.fields.manualModel);
				}
				formData.append("personnummer", this.fields.personnummer);
				formData.append("korkort_giltigt_till", this.fields.licenseValidUntil);
				formData.append("i", this.fields.userId);
				formData.append("test_drive_policy", this.fields.testDrivePolicy ? "1" : "0");
				formData.append("privacy_policy", this.fields.privacyPolicy ? "1" : "0");

				if (this.localEmailRecipients) {
					formData.append("email_recipients", this.localEmailRecipients);
				}
				if (this.localEmailSubject) {
					formData.append("email_subject", this.localEmailSubject);
				}

				fetch(window.nitea_utils_forms_test_drive_completed.admin_url + "?action=nitea_utils_form_post_test_drive_completed", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.success) {
							this.mailSentStatus = "sent";

							if (typeof window.niteaGTM !== "undefined") {
								window.niteaGTM.push({
									interaction_category: "form_test_drive_completed",
									interaction_type: "submit",
									interaction_status: "success",
									value: 5000,
									customer: {
										type: "private",
									},
									interaction_details: {
										id: "form_test_drive_completed",
										element_type: "form",
										location: this.isModalMode ? "modal" : "form_selector",
									},
									vehicle: {
										brand: this.car && this.car.brand ? this.car.brand : this.fields.manualBrand || null,
										model: this.car && this.car.model ? this.car.model : this.fields.manualModel || null,
										version: this.car && this.car.version ? this.car.version : null,
										model_year: this.car && this.car.model_year ? this.car.model_year : null,
										fuel_type: this.car && this.car.fuel_type_1 ? this.car.fuel_type_1 : null,
										gearbox: this.car && this.car.gearbox ? this.car.gearbox : null,
										registration_number: this.car && this.car.plate ? this.car.plate : this.fields.registrationNumber || null,
									},
									debug: true,
								});
							}

							this.resetForm();
						} else {
							this.mailSentStatus = "error";
						}
					})
					.catch((error) => {
						console.error("Error:", error);
						this.mailSentStatus = "error";
					});
			},
			resetForm() {
				const userId = this.fields.userId;
				this.fields = {
					firstName: "",
					lastName: "",
					email: "",
					mobilephone: "",
					registrationNumber: "",
					manualBrand: "",
					manualModel: "",
					personnummer: "",
					licenseValidUntil: "",
					userId: userId,
					testDrivePolicy: false,
					privacyPolicy: false,
				};
				this.car = null;
				this.registrationNumber = { isLoading: false, error: null };
				this.$v.$reset();
			},
		},
	};
</script>
